<template>
  <div class="member-info">
    <h4 class="member-info-title">会员信息</h4>
    <ul class="member-info-list">
      <!-- 会员|非会员 -->
      <li class="list-item">
        <span class="item-label">会员等级：</span>
        <span class="item-value">
          <img v-if="memberInfo.memberType >= 0 && memberInfo.memberType !== null" class="level" :src="getMemberSigleImg(memberInfo.memberType)" alt="" />
          {{ memberInfo.memberType > 0 ? memberInfo.memberCode : '普通会员' }}
          <a v-if="memberInfo.isSold === false" class="upgrade" :href="homeUrl + '/member/products'" target="_blank">
            <img class="upgrade-img" src="@/assets/image/common/upgrade-level.png" alt="" />
          </a>
        </span>
      </li>
      <!-- 会员 -->
      <li v-if="showExpiration" class="list-item">
        <span class="item-label">到期日期：</span>
        <span class="item-value">
          <span v-if="memberInfo.endDate">{{ memberInfo.endDate }}</span>
          <span v-if="hasRemainingDays" class="due">剩余{{ memberInfo.remainDays }}天</span>
        </span>
      </li>
      <li v-if="hasPendingService" class="list-item service-status">
        <span class="item-label">{{ $t('membershipValidity.serviceStatus') }}：</span>
        <span class="item-value service-value">
          <span class="service-state">{{ $t(memberInfo.serviceStatus === 2 ? 'membershipValidity.pendingActivation' : 'membershipValidity.renewed') }}</span>
          <span v-if="memberInfo.planActiveDate">{{ $t('membershipValidity.effectiveFrom', { date: memberInfo.planActiveDate }) }}</span>
          <a class="service-details" :href="platformContractUrl" target="_blank" rel="noopener">{{ $t('membershipValidity.details') }}</a>
        </span>
      </li>
      <!-- 宜昌专区 -->
      <li class="list-item" v-if="userInfo.clientSource">
        <span class="item-label">区域权限：</span>
        <span class="item-value" v-if="userInfo.clientSource == 10">
          宜昌专区用户
        </span>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { getMemberInfo } from '@/utils/api/dashboard';
import { onlineUrl, homeUrl } from '@/utils/config';

export default {
  data() {
    return {
      onlineUrl,
      homeUrl,
      memberInfo: {
        /**
         * memberType   //会员等级（非会员为0）
         * memberCode   //会员等级名
         * lifetime     //终身会员（0：普通，1：终身）
         * isSold       //是否Sold状态
         * startDate    //有效期开始时间
         * endDate      //有效期截止时间
         * remainDays   //当前生效会员未过期时的剩余天数
         * serviceStatus //1：生效中，2：新签待激活，3：已续约待生效
         * planActiveDate //已全款待激活合同的预计生效日，多个续约取最早开始日
         * contractType //10：新签，20：续约
         * contractStatus //4：激活生效，8：待激活
         */
      }
    }
  },
  computed: {
    ...mapState(['userInfo']),
    hasPendingService() {
      return [2, 3].includes(this.memberInfo.serviceStatus);
    },
    hasRemainingDays() {
      return Number.isFinite(this.memberInfo.remainDays) && this.memberInfo.remainDays >= 0;
    },
    showExpiration() {
      return this.memberInfo.serviceStatus !== 2
        && (this.memberInfo.serviceStatus === 3
          || this.memberInfo.isSold || this.memberInfo.memberType === 8)
        && Boolean(this.memberInfo.endDate || this.hasRemainingDays);
    },
    platformContractUrl() {
      return process.env.VUE_APP_PLATFORM_CONTRACT_URL
        || `${this.onlineUrl}/purchase-order/supplier/administration/platformContract`;
    },
  },
  methods: {
    getMemberInfo() {
      getMemberInfo()
      .then(res=> {
          if(res.rspResult.bizCode == 200) {
            this.memberInfo = res.data || {};
          }
        })
        .catch(err=> {
          console.error('查询会员信息失败', err)
        })
    },
    /**
     * 
     * @param {number} memberType 会员类型
     * @returns {string} 会员等级图片的地址
     */
    getMemberSigleImg(memberType) {
      if(memberType === 0) {
        return 'https://res.haizol.com/base/images/membership/new/vip0.png';
      }else if(memberType === 1) {
        return 'https://res.haizol.com/base/images/membership/new/vip_gold.png';
      }else if(memberType === 2 || memberType === 5) {
        return 'https://res.haizol.com/base/images/membership/new/vip_platinum.png';
      }else if(memberType === 3) {
        return 'https://res.haizol.com/base/images/membership/new/vip_diamond.png';
      }else if(memberType === 4) {
        return 'https://res.haizol.com/base/images/membership/new/vip_lifetime.png';
      }else if(memberType === 6) {
        return 'https://res.haizol.com/base/images/membership/vip_smartshow.png';
      }else if(memberType === 7) {
        return 'https://res.haizol.com/base/images/membership/new/vip_vvip.png';
      }else if(memberType === 8) {
        return 'https://res.haizol.com/base/images/membership/new/vip_engineering_expansion.png';
      }
      return '';
    }
  },
  created() {
    this.getMemberInfo();
  }
}

</script>

<style lang="scss" scoped>
.member-info {
  margin-bottom: 12px;
  background: #fff;
  padding: 20px 20px 20px 20px;
  box-shadow: 0 1px 6px 0 #001e3b12;
  &-title {
    height: 20px;
    line-height: 20px;
    font-family: SourceHanSansCN-Bold;
    font-weight: 700;
    font-size: 16px;
    color: #16181A;
    letter-spacing: 0;
    margin-bottom: 23px;
  }
  &-list {
    font-family: SourceHanSansCN-Regular;
    font-weight: 400;
    font-size: 14px;
    color: #4F5D78;
    line-height: 22px;
    .list-item {
      display: flex;
      align-items: center;
      margin-bottom: 5px;
      .item-label {
        flex-shrink: 0;
      }
      .item-value {
        display: flex;
        align-items: center;
        color: #16181A;
        font-size: inherit;
        .level {
          width: 18px;
          margin-right: 5px;
        }
        .upgrade {
          width: 80px;
          height: fit-content;
          margin-left: 10px;
          &-img {
            display: block;
            width: 100%;
          }
        }
        .due {
          margin-left: 6px;
          color: #ff7f2a;
        }
      }
      &:last-child(1) {
        margin-bottom: 0;
      }
      &.service-status {
        align-items: flex-start;
        .service-value {
          min-width: 0;
          flex-wrap: wrap;
          column-gap: 6px;
          .service-state {
            color: #ff7f2a;
          }
          .service-details {
            color: #066eb7;
          }
        }
      }
    }
  }
}
</style>
